// Zod-free leaf module: plain enums only (RET1-2734). Keep this file free of
// imports so lean bundles can use these values without loading zod schemas.

export enum ShipmentMethodName {
  PICKUP = "PICKUP",
  IN_STORE = "IN_STORE",
  SETTLEMENT = "SETTLEMENT",
  SELF_SHIP = "SELF_SHIP",
  HAPPY_RETURNS = "HAPPY_RETURNS",
  BLUE_YONDER = "BLUE_YONDER",
  /** @deprecated ReturnBear is retired; use DROPOFF. Parses stored draft returns only. */
  RETURN_BEAR = "RETURN_BEAR",
  MANUAL_LABEL = "MANUAL_LABEL", //Merchant will create the label and send it to the customer
  DROPOFF = "DROPOFF",
}
